/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.InsightsUserManagement {
    angular.module("meevo.plugins.insightsUserManagement", [])
        .run(['webComponentSetup', function (webComponentSetup: any) {
            webComponentSetup.register({ id: 'insights-user-management' });
        }]);
}
